import {NotificationsGroup} from './notifications-group.class';
import {NotificationsInterfaces} from '@namespaces/notifications.namespace';
import {NotificationMessage} from '@providers/notifications/notification-message';

/**
 * Фабрика для создания сгруппированных увдомлений из списка существующих
 */
export class NotificationsGroupFactory {
    /**
     * Создает коллекцию групп уведомлений, сгруппированных по дате
     * @param {NotificationsInterfaces.Message[]} items
     * @returns {NotificationsGroup[]}
     */
    static createGroups(items: NotificationMessage[] = []): NotificationsGroup[] {
        const groupsByDate = {};

        items.forEach(item => {
            if (!groupsByDate[item.date]) {
                groupsByDate[item.date] = [];
            }

            groupsByDate[item.date].push(item);
        });

        return Object.keys(groupsByDate).map(groupDate => new NotificationsGroup(groupDate, groupsByDate[groupDate]));
    }
}
